import { render, staticRenderFns } from "./UnplannedLeaveSection.vue?vue&type=template&id=492cf6a8&scoped=true"
import script from "./UnplannedLeaveSection.vue?vue&type=script&lang=js"
export * from "./UnplannedLeaveSection.vue?vue&type=script&lang=js"
import style0 from "./UnplannedLeaveSection.vue?vue&type=style&index=0&id=492cf6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492cf6a8",
  null
  
)

export default component.exports